module.exports = __webpack_public_path__ + "img/ep-diamant.01a8f130.jpg";